import { useEffect, useState } from 'react';
import { MaintenanceRecurrenceDetailModel } from 'api/models';
import MaintenanceTaskModel from 'models/maintenance/MaintenanceTaskModel';

// Both states below are typed rather than reseeded: `useState(null)` gave them
// the type `null`, so the four pages that hand the result to
// `MaintenanceRecurrence`/`MaintenanceRecurrentSubtask` could never satisfy
// those props. `null` stays in the union — a rejected fetch leaves the details
// unset while `isLoading` goes back to false, which is why both components
// already read their task through `?.`.
export const useMaintenanceRecurrenceTaskDetails = ({
  homeUniqueId,
  recurrenceType,
  fetchTask,
}: any) => {
  const [taskDetails, setTaskDetails] =
    useState<MaintenanceRecurrenceDetailModel | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchMaintenanceDetails = async () => {
      const response = await fetchTask(recurrenceType, homeUniqueId);
      setTaskDetails(response);
    };
    setIsLoading(true);
    fetchMaintenanceDetails()
      .then(() => {
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }, [recurrenceType, homeUniqueId, fetchTask]);

  return { taskDetails, isLoading };
};

export const useMaintenanceRecurrenceSubtaskDetails = ({
  subtaskId,
  fetchTask,
}: any) => {
  const [subtaskDetails, setSubtaskDetails] =
    useState<MaintenanceTaskModel | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchMaintenanceSubtaskDetails = async () => {
      if (subtaskId !== 'default') {
        const response = await fetchTask(subtaskId);
        setSubtaskDetails(response);
      }
    };
    setIsLoading(true);
    fetchMaintenanceSubtaskDetails()
      .then(() => {
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  }, [fetchTask, subtaskId]);

  return { subtaskDetails, isLoading };
};
